import { Link } from "react-router-dom";
import { IconButton } from "@mui/material";
import LinkedIn from "@mui/icons-material/LinkedIn";

import { RoutesConstants } from "@/main/routes/routesConstants";
import { getTranslateByKey } from "@/main/services/utils";
import logo from "@/main/assets/images/login/xnuup_main_logo_white.png";
import ButtonDemo from "@/main/screens/public/homepage/components/buttonDemo/buttonDemo";

import * as S from "./styles";

function Footer() {
	const LINKS_SUBPAGES = [
		{
			name: getTranslateByKey("information.forSuppliers"),
			url: RoutesConstants.homepageSupplier,
		},
		{
			name: getTranslateByKey("information.forBodyshops"),
			url: RoutesConstants.homepageBodyshop,
		},
		{
			name: getTranslateByKey("information.forInsurers"),
			url: RoutesConstants.homepageInsurer,
		},
	];

	function onClickLinkedin() {
		const link = "https://www.linkedin.com/company/xnuup/";
		window.open(link, "_blank");
	}
	const getCurrentYear = () => new Date().getFullYear();
	function onClickSubPage() {
		window.scrollTo({ top: 0 });
	}
	return (
		<S.Footer>
			<S.AreaCollumnsFooter>
				<S.AreaIconLogo>
					<Link to={RoutesConstants.home} onClick={onClickSubPage}>
						<S.Logo src={logo} />
					</Link>
					<IconButton onClick={onClickLinkedin}>
						<LinkedIn />
					</IconButton>
				</S.AreaIconLogo>

				<S.AreaSubPages>
					<S.WrapperSubPages>
						<S.TitleSubPages>{getTranslateByKey("information.solutions")}</S.TitleSubPages>
						{LINKS_SUBPAGES.map((link, index) => (
							<Link key={index} to={link.url} onClick={onClickSubPage}>
								<S.LinkSubPage>{link.name}</S.LinkSubPage>
							</Link>
						))}
					</S.WrapperSubPages>
					<S.WrapperSubPages>
						<S.TitleSubPages>{getTranslateByKey("information.company")}</S.TitleSubPages>
						<Link to={RoutesConstants.homepageAbout} onClick={onClickSubPage}>
							<S.LinkSubPage>{getTranslateByKey("information.aboutUs")}</S.LinkSubPage>
						</Link>
					</S.WrapperSubPages>
				</S.AreaSubPages>

				<S.AreaDemo>
					<ButtonDemo />
				</S.AreaDemo>
			</S.AreaCollumnsFooter>
			<S.AreaAllRights>
				<S.HorizontalLine />@{getCurrentYear()} Xnuup. {getTranslateByKey("information.allRightsReserved")}
			</S.AreaAllRights>
		</S.Footer>
	);
}

export default Footer;
